<!--
 * @author:
 * @Description: 设备清单
-->
<template>
  <div class="environmentalMonitoringList w-full h-full relative">
    <DiyButtonGroup
      class="my-10px !text-14px"
      @button-click="buttonClick"
      :value="btnValue"
      :textSize="'14px'"
      :list="['灯', '网关', '传感器', '回路']"
    ></DiyButtonGroup>
    <div class="icon-search__input mt-5px mb-5px">
      <el-input class="w-full" placeholder="请输入关键词" v-model="keyword" clearable>
        <i slot="append" class="el-icon-search cursor-pointer" @click="searchList"></i>
      </el-input>
    </div>
    <el-table
      ref="tableRef"
      height="calc(100% - 130px)"
      class="mt-10px"
      :data="tableData"
      highlight-current-row
      row-key="id"
    >
      <el-table-column label="设备名称" prop="devName" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ btnValue === '网关' ? scope.row.gwName : scope.row.devName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="在线状态" prop="onlineState" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.onlineState === 1">在线</span>
          <span v-else class="text-red-500">离线</span>
        </template>
      </el-table-column>
      <el-table-column
        label="设备状态"
        prop="status"
        show-overflow-tooltip
        v-if="btnValue !== '网关'"
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#2ce1d9"
            inactive-color="#637279"
            active-value="1"
            inactive-value="0"
            disabled
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('操作')}`" show-overflow-tooltip width="86">
        <template slot-scope="scope">
          <span class="w-15 cursor-pointer text-[#00BCC8]" @click="toDetail(scope.row)">
            查看
          </span>
          <span
            class="w-15 cursor-pointer text-[#00BCC8]"
            @click="toPosition(scope.row)"
            v-if="btnValue !== '网关'"
          >
            定位
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      small
      background
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="pageInfo.pageNo"
      :page-size.sync="pageInfo.pageSize"
      :pager-count="3"
      layout="total, prev, pager, next"
      :total="pageInfo.total"
      class="text-center"
    ></el-pagination>
    <GatewayDetailDialog
      v-if="isShowDialog"
      @refresh="refresh"
      :propsData="rowData"
      class="w-500px h-260px"
    />
    <DeviceDetailDialog
      v-if="isShowDeviceDetailDialog"
      @refresh="refresh"
      :propsData="rowData"
      class="w-920px h-530px"
    />
  </div>
</template>

<script>
import { LightingDeviceApi } from '@wiz-api/huizhou2-business'
import DiyButtonGroup from '../../../../cockpit-huizhou/components/global/DiyButtonGroup'
import GatewayDetailDialog from './gatewayDetailDialog'
import DeviceDetailDialog from './deviceDetailDialog'

const lightingDeviceApi = new LightingDeviceApi()
export default {
  name: 'lightingDeviceList',
  components: {
    DiyButtonGroup,
    GatewayDetailDialog,
    DeviceDetailDialog,
  },
  props: {
    cloudRender: {
      type: Object,
      default: null,
    },
    customProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    player: {
      type: Object,
      defalut: null,
    },
  },
  data() {
    return {
      btnValue: '灯',
      tableData: [],
      pageInfo: {
        total: 0,
        pageSize: 10,
        pageNo: 1,
      },
      isShowDialog: false,
      keyword: '',
      isShowDeviceDetailDialog: false,
      rowData: {},
      deviceMakerList: [],
      cameraMarkerIds: [],
    }
  },
  watch: {
    deviceMakerList(val) {
      this.delMarkers()
      this.createDeviceMarker()
    },
  },
  created() {
    this.getDeviceList()
    this.player && this.player.Native.GisMarker.EventGisMarkerLClick.connect(this.markerClick)
  },
  methods: {
    // 页签点击
    buttonClick(val) {
      this.btnValue = val
      this.keyword = ''
      this.getDeviceList()
    },
    // 搜索
    searchList() {
      this.pageInfo.pageNo = 1
      this.getDeviceList()
    },
    // 获取照明设备列表
    async getDeviceList() {
      this.tableData = []
      if (this.btnValue === '网关') {
        this.getgatewayListByDevType()
      } else {
        this.getDeviceListByDevType()
      }
    },
    // 获取照明设备列表
    async getDeviceListByDevType() {
      let devType = null
      switch (this.btnValue) {
        case '灯':
          devType = 12
          break
        case '传感器':
          devType = 13
          break
        case '回路':
          devType = 15
          break
        default:
          break
      }
      const [err, res] = await lightingDeviceApi.getLightingDeviceList({
        body: {
          devType,
          keyWord: this.keyword,
          isHome: true,
          maxResultCount: this.pageInfo.pageSize,
          skipCount: (this.pageInfo.pageNo - 1) * this.pageInfo.pageSize,
        },
      })
      if (!err) {
        this.tableData = res.items
        this.pageInfo.total = res.totalCount
        if (this.player && this.player.Native) {
          this.deviceMakerList = [] // 摄像头标记重置
          this.handleDeviceData()
        }
      }
    },
    // 获取网关设备列表
    async getgatewayListByDevType() {
      const [err, res] = await lightingDeviceApi.getLightingDeviceGatewayList({
        body: {
          maxResultCount: this.pageInfo.pageSize,
          skipCount: (this.pageInfo.pageNo - 1) * this.pageInfo.pageSize,
          gwName: this.keyword,
        },
      })
      if (!err) {
        this.tableData = res.items
        this.pageInfo.total = res.totalCount
      }
    },
    // 设备信息数据
    handleDeviceData() {
      const marksData = this.tableData.filter((item) => {
        return item.tag3DPositionDto
      })
      const deviceMakerList = marksData.map((item) => {
        return {
          id: item.id,
          pos:
            (item.tag3DPositionDto.threeDPosition &&
              JSON.parse(item.tag3DPositionDto.threeDPosition)) ||
            [],
          tagFileImgId: item.tag3DPositionDto.tagFileImgId,
          data: item,
        }
      })
      this.deviceMakerList = deviceMakerList
    },
    // 创建设备标记
    async createDeviceMarker() {
      this.deviceMakerList.forEach(async (item) => {
        await this.player.Native.GisMarker.loadImage(
          `data://../apps/markers/lightingDevice/${item.tagFileImgId || 'circuit_offline.png'}`,
          (id) => {
            const option = {
              id: item.id,
              pos: item.pos, // 定位点，世界坐标，三维向量
              imgSize: [32, 50],
              nodeOffset: [-16, -50], // 相对定位点的偏移量，二维向量
              imgId: id, // 图片id
              visible: true,
            }
            this.player.Native.GisMarker.create(option, (markerId) => {
              this.cameraMarkerIds.push({
                markerId,
                rowData: item.data,
              })
            })
          }
        )
      })
    },
    // 删除图标标记
    delMarkers() {
      if (!this.player || !this.player.Native) return
      _.forEach(this.cameraMarkerIds, (marker) => {
        this.player.Native.GisMarker.destroy(marker.markerId)
      })
      this.cameraMarkerIds = []
    },
    // 定位
    toPosition(row) {
      const tag3DPositionDto = row.tag3DPositionDto
      if (tag3DPositionDto && tag3DPositionDto.threeDAngleView) {
        const position = JSON.parse(tag3DPositionDto.threeDAngleView)
        this.cloudRender.Camera.moveCamera('CameraParam', position, 1)
      }
    },
    // 打开设备详情
    toDetail(row) {
      if (this.btnValue === '网关') {
        this.isShowDialog = true
        this.isShowDeviceDetailDialog = false
        this.rowData = row
      } else {
        this.isShowDialog = false
        this.isShowDeviceDetailDialog = true
        this.rowData = row
      }
    },
    currentChange(val) {
      this.pageInfo.pageNo = val
      this.getDeviceList()
    },
    sizeChange(val) {
      this.pageInfo.pageNo = 1
      this.pageInfo.pageSize = val
      this.getDeviceList()
    },
    refresh() {
      this.isShowDialog = false
      this.isShowDeviceDetailDialog = false
    },
    // 返回初始视角
    backInitPositon() {
      if (this.customProps?.sceneOptions?.jsonData) {
        const jsonData = JSON.parse(this.customProps.sceneOptions.jsonData)
        const cameraParams = jsonData.cameraParams
          ? JSON.parse(jsonData.cameraParams)
          : { eye: [-1028, 580, 13821], target: [-1028, 579, 85], up: [0, 1, 0] }
        this.cloudRender.Camera.moveCamera('CameraParam', cameraParams)
      }
    },
    // 标记点击
    markerClick(info) {
      const markerInfo = this.cameraMarkerIds.find((item) => {
        return item.markerId === info.markerId
      })
      if (markerInfo && markerInfo.rowData) {
        this.toDetail(markerInfo.rowData)
      }
    },
  },
  beforeDestroy() {
    this.delMarkers()
    this.backInitPositon()
    this.player && this.player.Native.GisMarker.EventGisMarkerLClick.disconnect(this.markerClick)
  },
}
</script>

<style lang="scss" scoped></style>
